module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2022_16.e6215b46.jpg";